import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';
import trackingEvent from 'utils/trackingEvent';

import { ModalWindow } from 'components/common/Elements/Elements';
import BodyModalTestUser from '../BodyModalTestUser/BodyModalTestUser';

import { getRequest } from 'utils/requests';

import classes from './ModalTestUser.module.scss';

const ModalTestUser = ({ isOpen, setIsOpen, activated = false, mixpanel }) => {
  const language = useUserState().user.language;
  const idUser = useUserState().user.id;
  const username = useUserState().user.username;

  const [modeActivated, setModeActivated] = useState(activated);

  const handleActivated = () => {
    trackingEvent('trial_ok', mixpanel, username);
    setModeActivated(true);

    getRequest(`/api/accounts/${idUser}/subscribe`)
      .then(() => {})
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <div>
      <ModalWindow
        stylesModal={{
          body: classes.modalUser,
          titleWrap: classes.modalTitleWrap,
          title: classes.modalTitle,
          iconClear: classes.iconClear
        }}
        headerText={t('statusTestUser', 'SUBSCRIPTION', language)}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      >
        {!modeActivated ? (
          <BodyModalTestUser onCancel={setIsOpen} onClickOk={handleActivated} />
        ) : (
          <div className={classes.bodyModalThanks}>
            <p className={classes.textTop}>
              {t('statusTestUser', 'REQUEST_SENT', language)}
            </p>
            <p>{t('statusTestUser', 'WILL_CONTACT', language)}</p>
          </div>
        )}
      </ModalWindow>
    </div>
  );
};

ModalTestUser.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func.isRequired,
  activated: PropTypes.bool,
  mixpanel: PropTypes.object
};

export default ModalTestUser;
